import React from 'react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Autoplay } from 'swiper'
// import Image from '../../../shared/Image'
import uid from '../../../shared/uid'

SwiperCore.use([Navigation, Autoplay])
const useStyles = makeStyles((theme) => ({
  root: {},
  headTitle: {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '29px',
    color: '#7557BB',
    textAlign: 'center',
    maxWidth: '420px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '40px',
    [theme.breakpoints.down('1280')]: {
      textAlign: 'center',
      marginBottom: 60,
      [theme.breakpoints.down('1280')]: {
        marginBottom: 30,
      },
    },
  },
  logoImg: {
    maxWidth: '100%',
    width: 'max-content',
    padding: '26px 20px',
    objectFit: 'contain',
    [theme.breakpoints.down('1500')]: {
      padding: ' 26px 20px',
      maxWidth: '80%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 10px',
      maxWidth: '90%',
    },
  },
  swiperMy: {
    width: '100%',
    '& .swiper-slide': {
      textAlign: 'center',
    },
  },
  newColor: {
    color: '#7c44ef',
  },
}))

const Partners = (props) => {
  const { data, newDesign } = props

  const classes = useStyles()

  return (
    <>
      {/* <div className={clsx(classes.root, className)} {...rest}> */}
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        data-aos="fade-up"
      >
        <Grid item xs={12}>
          <Typography
            variant="h5"
            className={`${classes.headTitle} ${
              newDesign ? classes.newColor : ''
            }`}
          >
            Trusted by giants in the film and television industry
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container className={classes.swiperMy}>
            <Swiper
              spaceBetween={0}
              loop
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={800}
              navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
              }}
              breakpoints={{
                374: {
                  slidesPerView: 2,
                  spaceBetween: 8,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 12,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 16,
                },
              }}
              className={classes.mySwiper}
            >
              {data.map((partner) => (
                <SwiperSlide key={uid()}>
                  {' '}
                  {partner.clienName}
                  <img
                    src={partner.logo}
                    className={classes.logoImg}
                    alt="partners-img"
                    // lazy={false}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            {/* <div className={classes.webNav}>
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div> */}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

Partners.propTypes = {
  data: PropTypes.array.isRequired,
}

export default Partners
